import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.link.js";
import React from 'react';
import { Trans } from 'react-i18next';
import { generatePath } from 'react-router';
import i18n from 'i18next';
import { AccessLink } from '../Components/AccessLink';
export function getAudienceText(_ref) {
  var id = _ref.id,
    audience = _ref.audience,
    teamIds = _ref.teamIds,
    isDeleted = _ref.isDeleted,
    tabLinks = _ref.tabLinks;
  var teamCount = _toConsumableArray(new Set(teamIds)).length;
  var accessTabLink = generatePath(tabLinks.access.link, {
    playlistId: id
  });
  if (audience === 'admin') {
    if (isDeleted) {
      return i18n.t('playlist_heading_visible_to_admins_only');
    }
    return /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "playlist_heading_visible_to_admins_only_link"
    }, 'Visible to', ' ', /*#__PURE__*/React.createElement(AccessLink, {
      accessTabLink: accessTabLink
    }, "admins only"));
  }
  if (audience === 'teams') {
    if (isDeleted) {
      return i18n.t('playlist_heading_visible_to_team', {
        count: teamCount
      });
    }
    return /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "playlist_heading_visible_to_team_link",
      count: teamCount
    }, 'Visible to', ' ', /*#__PURE__*/React.createElement(AccessLink, {
      accessTabLink: accessTabLink
    }, "count teams"));
  }
  if (isDeleted) {
    return i18n.t('playlist_heading_visible_to_everyone');
  }
  return /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "playlist_heading_visible_to_everyone_link"
  }, 'Visible to', ' ', /*#__PURE__*/React.createElement(AccessLink, {
    accessTabLink: accessTabLink
  }, "everyone"));
}